import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormProvider, useForm } from 'react-hook-form';

import { ProgressButton, UserInfoForm } from 'components';
import { useEditUserMutation, useGetUserQuery } from 'store/api/version-api.slice';

import USER_INFO_SCHEMA from './userInfo.schema';

const USER_INFO_FORM_DEFAULT_VALUES = profile => ({
	first_name: '',
	last_name: '',
	email: '',
	organization: '',
	...profile
});

const UpdateContactInfoDialog = ({ isOpen, toggleDialog }) => {
	const { data: profile = {} } = useGetUserQuery();
	const [editUser, { isLoading: isEditLoading }] = useEditUserMutation();

	const userInfoFormMethods = useForm({
		defaultValues: USER_INFO_FORM_DEFAULT_VALUES(profile),
		values: USER_INFO_FORM_DEFAULT_VALUES(profile),
		resolver: yupResolver(USER_INFO_SCHEMA)
	});

	const updateUserInfo = async data => {
		await editUser(data);

		toggleDialog();
	};

	return (
		<Dialog open={isOpen} onClose={toggleDialog} maxWidth={'md'} fullWidth={true}>
			<DialogTitle>Update Contact Information</DialogTitle>
			<FormProvider {...userInfoFormMethods}>
				<form onSubmit={userInfoFormMethods.handleSubmit(updateUserInfo)}>
					<DialogContent>
						<UserInfoForm />
					</DialogContent>
					<DialogActions>
						<Button variant="contained" onClick={toggleDialog} sx={{ backgroundColor: '#e0e0e0' }}>
							Cancel
						</Button>
						<ProgressButton
							isLoading={isEditLoading}
							button={
								<Button variant="contained" color="primary" type="submit">
									Save
								</Button>
							}
							circleColor={'secondary'}
						/>
					</DialogActions>
				</form>
			</FormProvider>
		</Dialog>
	);
};

export default UpdateContactInfoDialog;
